module.exports = __webpack_public_path__ + "img/internet_conference_build_a.3d4d15ca.png";